import { Controller, useFormContext } from 'react-hook-form';
import Select from 'react-select';
import { TextField } from '@client/new/components/basic';
import { FieldTitle } from './RedStarTitle';
import { FieldDesc } from './common';
import { OfferData } from './types';
import { toOfferOptions } from './offers';

type Props = {
  index: number;
  offers?: OfferData[];
};

export function OffersCarousel({ index, offers = [] }: Props) {
  const { register, control } = useFormContext();
  const r = (s: string) => register(`sections.${index}.${s}`);

  // Prepare options for the offers dropdown
  const offerOptions = toOfferOptions(offers);

  return (
    <div>
      <div className="max-w-[474px]">
        <FieldTitle title="Headline text" />
        <TextField
          {...r('title')}
          className="mb-[5px] w-full"
          inputProps={{
            placeholder: 'Headline text',
            maxLength: 60,
          }}
        />
      </div>

      <div className="max-w-[474px]">
        <FieldTitle title="Subtitle" optional />
        <TextField
          {...r('subtitle')}
          className="mb-[5px] w-full"
          inputProps={{
            placeholder: 'Subtitle text',
            maxLength: 120,
          }}
        />
      </div>

      <div className="mt-6">
        <FieldTitle title="Choose offers" optional />
        <FieldDesc>
          They will be displayed in selected order. By default, all offers are
          displayed.
        </FieldDesc>
        <Controller
          name={`sections.${index}.offerIds`}
          control={control}
          render={({
            field: { value, onChange, ref },
            fieldState: { error },
          }) => (
            <>
              <Select
                ref={ref}
                isMulti
                options={offerOptions}
                value={(value || [])
                  .map((id: number) =>
                    (offerOptions || []).find((p) => p.value === id),
                  )
                  .filter(Boolean)}
                onChange={(options) => onChange(options.map((o) => o.value))}
                placeholder="Select offers..."
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '56px',
                    borderColor: error ? '#d32f2f' : provided.borderColor,
                  }),
                }}
              />
              {error && (
                <div className="text-red-600 text-sm mt-1">{error.message}</div>
              )}
            </>
          )}
        />
      </div>
    </div>
  );
}
